import { RouteComponentProps } from "@reach/router";
import { APExpanded, APCenter, APColumn, APText, APButton, APSizedBox } from "ap-components";
import React from "react";

export default function DefaultPage(props: RouteComponentProps) {
  return (
    <APExpanded>
      <APCenter>
        <APColumn>
          <APText variant="dialogTitle">You may now close this page</APText>
        </APColumn>
      </APCenter>
    </APExpanded>
  );
}
